<template>

   <div class="uk-card uk-card-default uk-card-hover">

     <div class="uk-card-header">
      <div class="uk-card-title">Eligibility</div>
    </div>

    <div class="uk-card-body">
      <div class="card-stretch-container">
        <div class="bignumber secondary">
          <div class='number'>
            {{Math.abs(callsToBeEligible)}}
          </div>
          <div class='label'>
            Calls {{ callsToBeEligible > 0 ? "Until" : "Above"}} Eligibility
          </div>
        </div>

        <div class="bignumber secondary">
          <div class='number'>
            {{peerRank}}
          </div>
          <div class='label'>
            Rank Among {{orgType}}
          </div>
        </div>


        <!--<div class = "horizontal-chart">-->
            <!--<simple-stacked-bar-->
              <!--:chartdata="stackedBarData"-->
              <!--:max-val="eligibleVolume"-->
            <!--/>-->
        <!--</div>-->
      </div>
    </div>
   </div>

</template>

<script>


	import SimpleStackedBar from "../charts/SimpleStackedBar.vue"

	export default {
		name: "DriverVolumeCard",
		props: ["peerRank", "eligibleVolume", "volume", "orgType"],
		components: {
			SimpleStackedBar,
		},
		computed: {
			stackedBarData: function () {
				return [{
					'value': this.volume,
					'label': this.volume,
					'color': "#7657A7",
				}]
			},
      callsToBeEligible: function() {
				return this.eligibleVolume - this.volume
      }
		},
	}


</script>

<style lang="less" scoped>


  @import "../../assets/less/palette.less";
  @import "../../assets/less/theme.less";


  .card-stretch-container {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .uk-card {
    border: 1px solid @secondary-2;
  }

  .bignumber {



    .number {
      font-size: 60px;
    }

    .label {
      font-size: 12px;
    }
  }


  @media only screen and (max-width: @breakpoint-medium) {
      .card-stretch-container {
        flex-direction: column;
        justify-content: center;

        .bignumber {
           margin: 10px 0;
        }
      }
  }


</style>
